export function filterObject<Result = {[key: string]: any}> (obj: {[key: string]: any}, predicate: (key: string, value: any) => boolean): Result {
  const result: {[key: string]: any} = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && predicate(key, obj[key])) {
      result[key] = obj[key];
    }
  }

  return result as Result;
}

export function omitProperties<Result = {[key: string]: any}> (obj: {[key: string]: any}, properties: string[]): Result {
  return filterObject<Result>(obj, (key) => !properties.includes(key));
}

export function keepProperties <Result = {[key: string]: any}> (obj: {[key: string]: any}, properties: string[]): Result {
  return filterObject<Result>(obj, (key) => properties.includes(key));
}
